import React, { Component } from "react";
import CoverPageData from "./CoverPageData";
import CoverPageInfo from "./CoverPageInfo";
import { propertyUtil } from "views/Pma/PropertyUtil";
import KJTeamLogo from "_img/agentLogos/Kimm-Jen_LOGO_WHITE.png";
import MattTLogo from "_img/agentLogos/matt-t-transparent-logo.png";
import CoverPhotoUploadButton from "./CoverPhotoUploadButton";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { pmaActions } from "_store/_actions";
import { SaveCoverPhotoPreference } from "services/pma";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";
import "./print.scss";

class CoverPage extends Component {
  state = {
    useAlternatePhoto:
      this.props.currentArea?.coverPhotoPreference === "alternate",
    savingPhotoChoice: false,
  };

  componentDidUpdate(prevProps) {
    // re-sync with the saved preference when the area (or its saved value) changes
    const prev = prevProps.currentArea || {};
    const curr = this.props.currentArea || {};
    if (
      prev.mlsAreaID !== curr.mlsAreaID ||
      prev.coverPhotoPreference !== curr.coverPhotoPreference
    ) {
      this.setState({
        useAlternatePhoto: curr.coverPhotoPreference === "alternate",
      });
    }
  }

  handlePhotoChoice = async (useAlternatePhoto) => {
    const { agentData, coverPageDetails, currentArea } = this.props;
    const previous = this.state.useAlternatePhoto;
    const areaID =
      (coverPageDetails && coverPageDetails.areaID) ||
      (currentArea && currentArea.mlsAreaID);
    this.setState({ useAlternatePhoto, savingPhotoChoice: true });
    const preference = useAlternatePhoto ? "alternate" : "default";
    try {
      const saved = await SaveCoverPhotoPreference(
        agentData.listgenUserID,
        areaID,
        preference,
      );
      if (saved !== true) throw new Error("Preference not saved");
      // keep the store in sync only after a successful save
      this.props.updateCoverPhotoPreference(preference);
    } catch (e) {
      // revert and let the agent know
      this.setState({ useAlternatePhoto: previous });
      this.props.enqueueSnackbar("Unable to save cover photo preference.", {
        variant: "error",
      });
    }
    this.setState({ savingPhotoChoice: false });
  };

  divideAreas = (areas, hideText) => {
    const { currentArea, agentData, coverPageDetails } = this.props;

    const { coverPhoto, photographerArtistName } = coverPageDetails;
    const { listgenUserID } = agentData;
    const { mlsAreaID, coverPageTitle, mlsCityName, mlsNeighborhoodName } =
      currentArea;
    const { splitAreas } = propertyUtil;
    const { subdivisionName, coverPageHeader } = this.props.hoData;
    const isRawCoverPageTitle =
      coverPageTitle &&
      coverPageTitle.startsWith("*") &&
      !coverPageTitle.includes("*/*");
    const rawCoverPageTitle = isRawCoverPageTitle
      ? coverPageTitle.slice(1)
      : coverPageTitle;
    let areaSplit = isRawCoverPageTitle
      ? [rawCoverPageTitle]
      : splitAreas(
          subdivisionName
            ? subdivisionName
            : coverPageTitle
              ? coverPageTitle
              : coverPageHeader
                ? coverPageHeader
                : areas,
        );

    let totalCharacters;
    if (subdivisionName && subdivisionName.length) {
      totalCharacters = subdivisionName.length;
    } else if (rawCoverPageTitle && rawCoverPageTitle.length) {
      totalCharacters = rawCoverPageTitle.length;
    } else if (coverPageHeader && coverPageHeader.length) {
      totalCharacters = coverPageHeader.length;
    } else if (areas && areas.length) {
      totalCharacters = areas.length;
    }

    let len = areaSplit.length;

    let maxCount;
    if (len === 1) {
      maxCount = areaSplit[0].length;
    } else if (len === 2) {
      maxCount = Math.max(areaSplit[0].length, areaSplit[1].length);
    } else if (len === 3) {
      maxCount = Math.max(
        areaSplit[0].length,
        areaSplit[1].length,
        areaSplit[2].length,
      );
    }
    let lineSeparatorStyles = "";
    let coverPageFontSize = "";
    let specialMargins;
    if (mlsAreaID === "MRN-A0300D") {
      coverPageFontSize = "cover-font-33-no-uppercase";
    } else if (mlsAreaID === "MRN-A1400J") {
      coverPageFontSize = "cover-font-41";
    } else if (mlsAreaID === "CCA-1800K") {
      coverPageFontSize = "el-cerrito-cover-text no-uppercase-cover-text";
    } else if (mlsAreaID === "SNM-B1300N") {
      coverPageFontSize = "cover-font-63-bold";
    } else if (mlsAreaID === "NPA-E0400Y") {
      coverPageFontSize = "playfair-text";
    } else if (mlsAreaID === "SCL-16D") {
      coverPageFontSize = "high-centered-cover-text-neg-268-font-31";
    } else if (mlsAreaID === "CCA-4800E") {
      coverPageFontSize = "upper-left-corner-area-text";
    } else if (mlsAreaID === "SMA-263A") {
      coverPageFontSize = "bolded-cover-photo-text cover-page-area-text-47";
    } else if (listgenUserID === "104504" || mlsAreaID === "SCL-3AC") {
      coverPageFontSize = "higher-cover-page-text";
    } else if (listgenUserID === "106531") {
      coverPageFontSize = "bolded-cover-photo-text";
    } else if (listgenUserID === "106028") {
      coverPageFontSize = "bolded-cover-photo-text cover-text-47";
    } else if (mlsAreaID === "SMA-467") {
      coverPageFontSize = "cover-page-text-40";
    } else if (mlsAreaID === "SMA-395") {
      coverPageFontSize = "cover-page-text-font-39";
    } else if (mlsAreaID === "SCL-15A" || mlsAreaID === "SCL-10K") {
      coverPageFontSize = "medium-cover-page-area-text";
    } else if (
      mlsAreaID === "SBA-20FInv" ||
      mlsAreaID === "48E" ||
      mlsAreaID === "SMA-353A"
    ) {
      coverPageFontSize = "xxs-cover-page-area-text";
    } else if (
      areaSplit[0] === "Winchester Canyon" ||
      areas === "Country Club Gate/Forest Grove"
    ) {
      coverPageFontSize = "xs-cover-page-area-text";
    } else if (
      mlsAreaID === "SMA-398" ||
      mlsAreaID === "SMA-392" ||
      mlsAreaID === "ALA-3900V" ||
      mlsAreaID === "ALA-4000S" ||
      mlsAreaID === "CCA-4500H"
    ) {
      coverPageFontSize = "cover-page-area-text-37";
    } else if (mlsAreaID === "CCA-5200D") {
      coverPageFontSize = "cover-page-area-text-34";
    } else if (areas === "Carmel Valley Village/Los Tulares/Sleepy Hollow") {
      coverPageFontSize = "small-cover-page-area-text";
    } else if (maxCount >= 17) {
      coverPageFontSize = "medium-cover-page-area-text";
    }

    let oneLineOneArea = ["Country Club West", "Country Club East"];

    if (mlsAreaID === "SFO-7BD") {
      specialMargins = "ph-nov-2026"; //remove for December
    } else if (listgenUserID === "113592") {
      specialMargins = "fitz-higher-cover-text";
    } else if (mlsAreaID === "CCA-4600C") {
      specialMargins = "cover-text-margin-top-90";
    } else if (mlsAreaID === "SMA-610" || mlsAreaID === "SMA-621") {
      specialMargins = "cover-text-margin-top-160";
    } else if (mlsAreaID === "ALA-3900V") {
      specialMargins = "margin-top-neg-80-cover-text";
    } else if (listgenUserID === "102843") {
      specialMargins = "galli-cover-text-margin";
    } else if (mlsAreaID === "SCL-16N") {
      specialMargins = "monte-sereno-higher-cover-text";
    } else if (listgenUserID === "104626") {
      specialMargins = "higher-cover-page-text-2";
    } else if (listgenUserID === "104835") {
      if (
        mlsAreaID === "SMA-448" ||
        mlsAreaID === "SMA-438" ||
        mlsAreaID === "SMA-436"
      ) {
        specialMargins = "xdwyer-cover-text-margin homeplace-margin-cover";
      } else {
        specialMargins = "xdwyer-cover-text-margin aragon-margin-cover";
      }
    } else if (
      coverPhoto &&
      (coverPhoto.includes("white-patio") ||
        coverPhoto.includes("FiresideTable_January2025_lt"))
    ) {
      if (totalCharacters && totalCharacters >= 23) {
        specialMargins = "double-line-high-patio-text";
      } else if (listgenUserID === "104747") {
        specialMargins = "black-patio-text-on-wall";
      } else {
        specialMargins = "high-patio-text-1";
      }
    } else if (mlsAreaID === "SMA-621" || mlsAreaID === "SBA-45E") {
      specialMargins = "higher-cover-page-text";
    } else if (listgenUserID === "102712" || mlsAreaID === "SCL-239A") {
      specialMargins = "cover-text-margin-top-neg-170";
    } else if (mlsAreaID === "SBA-35J") {
      specialMargins = "higher-cover-page-text-100";
    }
    let dontShowCover = false;

    if (
      hideText ||
      (photographerArtistName &&
        photographerArtistName.includes("Hide Area Name"))
    ) {
      dontShowCover = true;
    } else if (listgenUserID === "102843") {
      dontShowCover = true;
    }

    if (listgenUserID === "107243") {
      lineSeparatorStyles = "line-separator-1";
    }
    if (listgenUserID === "x109954") {
      coverPageFontSize += " black-cover-text";
      lineSeparatorStyles = "black-line-separator";
    }
    if (listgenUserID === "x107373" || listgenUserID === "x107876") {
      coverPageFontSize += " black-cover-text";
    }
    if (dontShowCover) {
      return "";
    } else if (isRawCoverPageTitle) {
      return (
        <div
          className={`one-cover-page-area ${
            mlsAreaID === "xSBA-20I" ? "larger-one-cover-area" : ""
          } ${coverPageFontSize ? coverPageFontSize : ""} ${specialMargins}`}
        >
          <div>{rawCoverPageTitle}</div>
        </div>
      );
    }
    if (mlsAreaID === "SCL-233A") {
      //remove for Ocober
      return (
        <div className={`one-cover-page-area right-aligned-1`}>
          <div>Monroe Park</div>
          <div>Greenmeadow</div>
        </div>
      );
    } else if (mlsAreaID === "SNM-B1300F") {
      return (
        <div className={`one-cover-page-area cover-font-35 ${specialMargins}`}>
          <div>TEMELEC | CREEKSIDE | CHANTARELLE</div>
        </div>
      );
    } else if (mlsAreaID === "MRN-A0300D") {
      let breakSplit = coverPageTitle.split("<divider>");
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Marin Estates | Mariner Highlands
          </div>

          <div className={`subdivision-title ${coverPageFontSize}`}>
            Madera del Presidio | Meadowcreek Station
          </div>

          <div className={`subdivision-title ${coverPageFontSize}`}>
            Mariner Green
          </div>
        </div>
      );
    } else if (mlsAreaID === "MRN-A1700D") {
      return (
        <div
          className={`one-cover-page-area cover-font-45 ${specialMargins} mt-neg-100`}
        >
          <div>Madera Marin</div>
          <div>San Marin</div>
        </div>
      );
    } else if (mlsAreaID === "ALA-3900S") {
      return (
        <div
          className={`one-cover-page-area ${
            mlsAreaID === "xSBA-20I" ? "larger-one-cover-area" : ""
          } ${coverPageFontSize ? coverPageFontSize : ""} mt-27-font-39`}
        >
          <div>Pleasanton Valley</div>
        </div>
      );
    } else if (mlsAreaID === "ALA-3900Q") {
      return (
        <div
          className={`one-cover-page-area ${
            mlsAreaID === "xSBA-20I" ? "larger-one-cover-area" : ""
          } ${coverPageFontSize ? coverPageFontSize : ""} mt-27-font-39`}
        >
          <div>Jensen | Amador</div>
        </div>
      );
    } else if (mlsAreaID === "167") {
      return (
        <div
          className={`one-cover-page-area ${
            coverPageFontSize ? coverPageFontSize : ""
          } ${specialMargins}`}
        >
          <div>{areaSplit[0]}</div>
          <div className="cover-photo-subtitle">
            & Surrounding Neighborhoods
          </div>
        </div>
      );
    } else if (mlsAreaID === "48A") {
      return (
        <div className="three-cover-page-area">
          <div>Rio Del Mar</div>
          <div>Seascape & Highlands</div>
          <div>Neighborhoods</div>
        </div>
      );
    } else if (mlsAreaID === "CCA-5900F") {
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Silver Creek II & Westwood
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Clayton Greens
          </div>
        </div>
      );
    } else if (mlsAreaID === "CCA-5900E") {
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Black Diamond &
          </div>

          <div className={`subdivision-title ${coverPageFontSize}`}>
            Chaparral Springs
          </div>
        </div>
      );
    } else if (mlsAreaID === "SMA-377") {
      return (
        <div
          className={`one-cover-page-area  ${coverPageFontSize} ${specialMargins}`}
        >
          <p>{coverPageTitle}</p>
        </div>
      );
    } else if (mlsAreaID === "ALA-3900AD") {
      return (
        <div className="flashberger-cover-title no-caps">
          <p>Val Vista Real Estate Market Report</p>
        </div>
      );
    } else if (listgenUserID === "107253") {
      return (
        <div className="flashberger-cover-title">
          <p>NEIGHBORHOOD REAL ESTATE MARKET REPORT</p>
        </div>
      );
    } else if (coverPageTitle && coverPageTitle.includes("*/*")) {
      let newSplit = coverPageTitle.split("*/*");
      return (
        <div
          className={`one-cover-page-area ${
            mlsAreaID === "xSBA-20I" && "larger-one-cover-area"
          } ${coverPageFontSize} ${specialMargins}`}
        >
          <div>
            {newSplit[0]} / {newSplit[1]}
          </div>
        </div>
      );
    } else if (mlsAreaID === "127" && !subdivisionName) {
      return (
        <div
          className={`one-cover-page-area ${coverPageFontSize} regular-case-cover-area-title mt-neg-157-font-44`}
        >
          <div>Asilomar | Grove Acre | Crocker</div>
        </div>
      );
    } else if (mlsAreaID === "SMA-360A") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`one-cover-page-area`}>Hallmark Area</div>
        </div>
      );
    } else if (mlsAreaID === "SMA-304") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`one-cover-page-area`}>Downtown and</div>
          <div className={`one-cover-page-area `}>Allied Arts</div>
        </div>
      );
    } else if (mlsAreaID === "xSMA-607") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Alsace Lorraine
          </div>
          <div className={`subdivision-title ${coverPageFontSize} `}>
            & Arleta Park
          </div>
        </div>
      );
    } else if (mlsAreaID === "SCL-16L") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`one-cover-page-area`}>Belgatos</div>
          <div
            className={`one-cover-page-area cover-page-area-text-32 area-text-capitalized`}
          >
            and Surrounding Communities
          </div>
        </div>
      );
    } else if (mlsAreaID === "SCL-16M") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Bellaterra
          </div>
          <div className={`subdivision-title ${coverPageFontSize} `}>
            @ North 40
          </div>
        </div>
      );
    } else if (mlsAreaID === "SCL-1SB") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Borello Ranch Estates
          </div>
          <div className={`subdivision-title ${coverPageFontSize} `}>&</div>
          <div className={`subdivision-title ${coverPageFontSize} `}>
            Alicante
          </div>
        </div>
      );
    } else if (listgenUserID === "101001") {
      return (
        <div className="vait-cover-title-container">
          <div className="vait-cover-title">{areaSplit[0]}</div>
          <div className="vait-market-title">Market Analysis</div>
        </div>
      );
    } else if (coverPageTitle && coverPageTitle.includes("<br />")) {
      let breakSplit = coverPageTitle.split("<br />");
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {breakSplit[0]}
          </div>
          <div className={`subdivision-title ${coverPageFontSize} `}>
            {breakSplit[1]}
          </div>
          {breakSplit[2] && (
            <div className={`subdivision-title ${coverPageFontSize} `}>
              {breakSplit[2]}
            </div>
          )}
        </div>
      );
    } else if (coverPageTitle && coverPageTitle.includes("<divider>")) {
      let breakSplit = coverPageTitle.split("<divider>");
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {breakSplit[0]}
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {breakSplit[1]}
          </div>
          {breakSplit[2] && (
            <div
              className={`cover-photo-line-separator ${lineSeparatorStyles}`}
            ></div>
          )}
          {breakSplit[2] && (
            <div className={`subdivision-title ${coverPageFontSize}`}>
              {breakSplit[2]}
            </div>
          )}

          {breakSplit[3] && (
            <div
              className={`cover-photo-line-separator ${lineSeparatorStyles}`}
            ></div>
          )}
          {breakSplit[3] && (
            <div className={`subdivision-title ${coverPageFontSize}`}>
              {breakSplit[3]}
            </div>
          )}
        </div>
      );
    } else if (mlsAreaID === "SCL-16A") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Almond Grove
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Glen Ridge
          </div>
        </div>
      );
    } else if (mlsAreaID === "SMA-390") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title-single-line ${coverPageFontSize}`}>
            {areaSplit[0]}
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title-single-line ${coverPageFontSize}`}>
            {areaSplit[1]}
          </div>
        </div>
      );
    } else if (mlsAreaID === "SMA-398") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Treasure Isle - {areaSplit[0]}
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {mlsCityName}
          </div>
        </div>
      );
    } else if (mlsAreaID === "SMA-392") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Isle Cove - Neighborhood 9
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {mlsCityName}
          </div>
        </div>
      );
    } else if (coverPageHeader === "Upper East and Lower Mission Canyon") {
      return (
        <div className="qv4-subdivision-container">
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Lower Mission Canyon
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Upper East
          </div>
        </div>
      );
    } else if (mlsAreaID === "CCA-4500H") {
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Diablo West
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            Rancho Ramon / Las Lomitas
          </div>
        </div>
      );
    } else if (oneLineOneArea.includes(areaSplit[0])) {
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {areaSplit[0]}
          </div>
        </div>
      );
    } else if (len === 3) {
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {areaSplit[0]}
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {areaSplit[1]}
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {areaSplit[2]}
          </div>
        </div>
      );
    } else if (len === 1) {
      return (
        <div
          className={`one-cover-page-area ${
            mlsAreaID === "xSBA-20I" ? "larger-one-cover-area" : ""
          } ${coverPageFontSize ? coverPageFontSize : ""} ${specialMargins}`}
        >
          <div>{areaSplit[0]}</div>
        </div>
      );
    } else if (len === 2) {
      return (
        <div className={`qv4-subdivision-container ${specialMargins}`}>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {areaSplit[0]}
          </div>
          <div
            className={`cover-photo-line-separator ${lineSeparatorStyles}`}
          ></div>
          <div className={`subdivision-title ${coverPageFontSize}`}>
            {areaSplit[1]}
          </div>
        </div>
      );
    } else {
      return (
        <div className="three-cover-page-area">
          <div>{areaSplit[0]}</div>
          <div>{areaSplit[1]}</div>
          <div>{areaSplit[2]}</div>
        </div>
      );
    }
  };
  determineComparison = () => {
    const {
      quarterlyAreaTable,
      marketHighLightsData,

      agentData,
    } = this.props;
    const { listgenUserID } = agentData;

    let dataObj = {
      compareDays: null,
      salePriceDiff: null,
      salePriceDataPoint: null,
      receivedPerc: null,
      receivedDataPoint: null,
      daysToSellPerc: null,
      daysToSellDataPoint: null,
      unitsSoldPerc: null,
      unitsSoldDataPoint: null,
      monthComparison: null,
      highestSalePrice: null,
      useMedianSalePrice: false,
    };

    const {
      current180DaysAvgSalePrice,
      current180DaysAvgDOM,
      current180DaysUnitsSold,
      current90DaysAvgSalePrice,
      current90DaysAvgDOM,
      current90DaysUnitsSold,
      current270DaysAvgDOM,
      current270DaysAvgSalePrice,

      current270DaysUnitsSold,
      avgSalePrice90DaysPercentage,
      avgDaysOnMarket90DaysPercentage,
      soldCount90DaysPercentage,
      avgSalePrice180DaysPercentage,
      avgDaysOnMarket180DaysPercentage,
      soldCount180DaysPercentage,
      avgSalePrice270DaysPercentage,
      avgDaysOnMarket270DaysPercentage,
      soldCount270DaysPercentage,

      current90DaysMedianSalePrice,

      current180DaysMedianSalePrice,

      current270DaysMedianSalePrice,

      last12MonthsMedianSalePrice,

      median90DaysPercentage,
      median12MonthsPercentage,
      median180DaysPercentage,
      median270DaysPercentage,
    } = marketHighLightsData || {};

    let useMedian = false;
    if (
      listgenUserID === "105810" ||
      listgenUserID === "102548" ||
      listgenUserID === "105227"
    ) {
      useMedian = true;
      dataObj.useMedianSalePrice = true;
    }
    if (
      listgenUserID === "102743" ||
      listgenUserID === "105810" ||
      listgenUserID === "106028"
      // current90DaysAvgSalePrice &&
      // Number(+current90DaysAvgSalePrice) > 0 &&
      // mlsAreaID !== "SBA-20K" &&
      // mlsAreaID !== "SBA-20I" &&
      // current90DaysUnitsSold > 1
    ) {
      dataObj.compareDays = "90 Days";
      dataObj.monthComparison = 3;
      dataObj.salePriceDataPoint = useMedian
        ? current90DaysMedianSalePrice
        : current90DaysAvgSalePrice;
      dataObj.salePriceDiff = useMedian
        ? median90DaysPercentage
        : avgSalePrice90DaysPercentage;
      dataObj.daysToSellDataPoint = current90DaysAvgDOM;
      dataObj.daysToSellPerc = avgDaysOnMarket90DaysPercentage;
      dataObj.unitsSoldDataPoint = current90DaysUnitsSold;
      dataObj.unitsSoldPerc = soldCount90DaysPercentage;
      return dataObj;
    } else if (
      current180DaysAvgSalePrice &&
      +current180DaysAvgSalePrice > 0 &&
      listgenUserID !== "102548"
    ) {
      dataObj.compareDays = "6 Months";
      dataObj.monthComparison = 6;
      dataObj.salePriceDataPoint = useMedian
        ? current180DaysMedianSalePrice
        : current180DaysAvgSalePrice;
      dataObj.salePriceDiff = useMedian
        ? median180DaysPercentage
        : avgSalePrice180DaysPercentage;
      dataObj.daysToSellDataPoint = current180DaysAvgDOM;
      dataObj.daysToSellPerc = avgDaysOnMarket180DaysPercentage;
      dataObj.unitsSoldDataPoint = current180DaysUnitsSold;
      dataObj.unitsSoldPerc = soldCount180DaysPercentage;
      return dataObj;
    } else if (
      current270DaysUnitsSold &&
      +current270DaysUnitsSold > 0 &&
      listgenUserID !== "102548"
    ) {
      dataObj.compareDays = "270 Days";
      dataObj.monthComparison = 9;
      dataObj.salePriceDataPoint = useMedian
        ? current270DaysMedianSalePrice
        : current270DaysAvgSalePrice;
      dataObj.salePriceDiff = useMedian
        ? median270DaysPercentage
        : avgSalePrice270DaysPercentage;
      dataObj.daysToSellDataPoint = current270DaysAvgDOM;
      dataObj.daysToSellPerc = avgDaysOnMarket270DaysPercentage;
      dataObj.unitsSoldDataPoint = current270DaysUnitsSold;
      dataObj.unitsSoldPerc = soldCount270DaysPercentage;
      return dataObj;
    } else if (
      quarterlyAreaTable.marketTrends.filter(
        (obj) => obj.TrendName === "1-Year Trending",
      )[0].AvgSalePrice > 0
    ) {
      const {
        marketTrends: marketTrendsArea,
        marketTrendsPercentage: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "1-Year Trending",
      )[0];
      // let currentYearObjArea = marketTrendsArea.filter(
      //   (obj) => obj.TrendName === "1 Year Trends Percentage"
      // )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "1 Year Trends Percentage",
      )[0];

      dataObj.compareDays = "12 Months";
      dataObj.monthComparison = 12;
      dataObj.salePriceDataPoint = useMedian
        ? last12MonthsMedianSalePrice
        : currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = useMedian
        ? median12MonthsPercentage
        : currentYearAreaPerc.PercentageAvgSalePrice;
      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      return dataObj;
    } else {
      const {
        marketTrends: marketTrendsArea,
        marketTrendsPercentage: marketTrendsPercArea,
      } = quarterlyAreaTable;

      let currentYearObjArea = marketTrendsArea.filter(
        (obj) => obj.TrendName === "3-Year Trending",
      )[0];

      let currentYearAreaPerc = marketTrendsPercArea.filter(
        (obj) => obj.TrendPercentageName === "3 Years Trends Percentage",
      )[0];

      dataObj.compareDays = "3 Years";
      dataObj.monthComparison = 36;
      dataObj.salePriceDataPoint = currentYearObjArea.AvgSalePrice;
      dataObj.salePriceDiff = currentYearAreaPerc.PercentageAvgSalePrice;
      dataObj.daysToSellDataPoint = currentYearObjArea.AvgDaysOnMarket;

      dataObj.daysToSellPerc = currentYearAreaPerc.PercentageAvgDaysOnMarket;

      dataObj.unitsSoldDataPoint = currentYearObjArea.HomesSold;
      dataObj.unitsSoldPerc = currentYearAreaPerc.PercentageNumberOfHomesSold;

      return dataObj;
    }
  };

  render() {
    const {
      agentData,
      coverPageDetails,
      currentArea,

      version,
      printVersion,
      fromEditor,

      quadrantModalOpen,
      isDemo,
      hoData,
      hasFlippedTeam,
      showAllEditButtons,
    } = this.props;
    const { listgenUserID, teamName } = agentData;

    let {
      coverPhotoCredit1,
      coverPhotoCredit2,
      agentComment,
      photographerArtistName,
    } = coverPageDetails;
    let coverPhotoCredit3;
    //removed cover credit here
    let {
      mlsNeighborhood,
      mlsAreaID,

      isCoverPhotoDataVisible,
    } = currentArea;
    //comment first page
    const { isPrintMode, pmaPrintDate } = hoData;

    const determineComparison = this.determineComparison();
    let date = new Date();
    const today = `${date.getDate()}`;
    const month = date.toLocaleString("default", { month: "long" });
    const thisYear = date.getFullYear();
    let photoName;
    let isKazemiTeam = listgenUserID === "102712";
    const isSummerChe = listgenUserID === "104113";
    let cityPhoto =
      mlsAreaID === "SCL-209A"
        ? "https://d2onbxnrte2nim.cloudfront.net/non-covers/120925_CuestaPark_GalliTeam.jpg"
        : mlsAreaID === "SCL-207B"
          ? "https://d2onbxnrte2nim.cloudfront.net/non-covers/120925_ShorelineWest_GalliTeam.jpg"
          : mlsAreaID === "SCL-207A"
            ? "https://d2onbxnrte2nim.cloudfront.net/non-covers/011226_DowntownMtView_GalliTeam.jpg"
            : isSummerChe
              ? `https://d2onbxnrte2nim.cloudfront.net/041125_LakeVason_Octavio-SummerChe.jpg`
              : listgenUserID === "x109954"
                ? `https://d2onbxnrte2nim.cloudfront.net/081325_Shadow-Tassajara_+AnnMarieNugent_SCREENED-permanent.jpg`
                : isKazemiTeam
                  ? "https://d2onbxnrte2nim.cloudfront.net/Lila_Team_BlossomManor_Feb2025_2.jpg"
                  : listgenUserID === "103" && version === "table-quadrants"
                    ? "https://d2onbxnrte2nim.cloudfront.net/cover-oct-1.jpg"
                    : listgenUserID === "103" && version === "speedometer"
                      ? "https://d2onbxnrte2nim.cloudfront.net/cover-oct-2.jpg"
                      : listgenUserID === "103" && version === "bubble-compare"
                        ? "https://d2onbxnrte2nim.cloudfront.net/cover-oct-3.jpg"
                        : photoName && photoName.length > 1
                          ? photoName
                          : coverPageDetails && coverPageDetails.coverPhoto
                            ? coverPageDetails.coverPhoto
                            : "https://d2onbxnrte2nim.cloudfront.net/solid-black.png";

    let creditStyle;

    if (listgenUserID === "104742") {
      creditStyle = "top-left-credit";
    } else if (listgenUserID === "116936" || listgenUserID === "107230") {
      creditStyle = "cover-credit-hide";
    } else if (listgenUserID === "107253") {
      if (mlsAreaID === "ALA-3900AK") {
        creditStyle = "flashberger-cover-credit lowered-flashberger-credit";
      } else if (mlsAreaID === "ALA-3900AD") {
        creditStyle = "flashberger-cover-credit val-vista-credit";
      } else {
        creditStyle = "flashberger-cover-credit flashberger-bottom-282";
      }
    } else if (
      coverPhotoCredit1 &&
      coverPhotoCredit1.length > 100 &&
      listgenUserID === "101567"
    ) {
      creditStyle = "cover-credit-12";
    } else if (listgenUserID === "106031") {
      creditStyle = "bolded-cover-credit";
    } else if (coverPhotoCredit1 && coverPhotoCredit1.length > 112) {
      creditStyle = "smaller-size-credit";
    } else if (coverPhotoCredit1 && coverPhotoCredit1.length > 95) {
      creditStyle = "medium-size-credit";
    } else if (listgenUserID === "104480") {
      creditStyle = "larger-credit-size-1";
    } else if (
      mlsAreaID === "SCL-19N" ||
      mlsAreaID === "SCL-19O" ||
      listgenUserID === "102450"
    ) {
      creditStyle = "italicized-credit";
    } else if (listgenUserID === "101566") {
      creditStyle = "gummow-credit-style";
    } else if (listgenUserID === "101567") {
      creditStyle = "kaufman-credit";
    } else if (listgenUserID === "100988") {
      creditStyle = "dianne-johnson-credit";
    } else if (listgenUserID === "107373" || listgenUserID === "107876") {
      creditStyle = "right-aligned-credit";
    } else if (listgenUserID === "109954") {
      creditStyle = "no-show-credit";
    } else if (listgenUserID === "104835") {
      creditStyle = "credit-bottom-60";
    } else if (listgenUserID === "112360" || listgenUserID === "112350") {
      creditStyle = "cover-credit-17";
    }
    let coverDateStyles;
    if (listgenUserID === "106028") {
      coverDateStyles = "bolded-cover-data-text";
    }

    // const isKerrySmith = listgenUserID === "102340";
    // let specialKerrySmithQR = (
    //   <div className="kerry-smith-cover-qr-container">
    //     <img
    //       src={hoData.homeOwnerURLQRCodePath}
    //       alt="Kerry Smith QR"
    //       className="kerry-smith-cover-qr"
    //     />
    //   </div>
    // );

    const isVaitCover = listgenUserID === "101001";

    let specialVait = (
      <div className="special-vait-above-cover-title">
        <div className="vait-logo-container">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/072023_AnnetteVait_LOGO-White_4Cover.png"
            alt="Annette Vait Logo"
          />
        </div>
        <div className="vait-presents-container">
          <div className="vait-presents-text">
            Annette Vait Presents your {month}, {thisYear}
          </div>
        </div>
      </div>
    );
    const isHeatherDonovan = listgenUserID === "x109873";

    let specialHeatherDonovan = (
      <div className="heather-donovan-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/021126_heatherDonovan_Agent-YR-logo.png"
          alt="Heather Donovan Logo"
          className="heather-donovan-cover-logo"
        />
      </div>
    );

    let specialHeatherDonovan2 = (
      <div className="heather-donovan-cover-logo-container-2">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050426_HeatherDonovan_badge-2.png"
          alt="Heather Donovan Logo"
          className="heather-donovan-cover-logo-2"
        />
      </div>
    );

    const isKJTeam = listgenUserID === "106028";
    let specialKJTeam = (
      <div className="special-kj-team-logo-container">
        <img src={KJTeamLogo} alt="KJ Team Logo" className="kj-team-logo-img" />
      </div>
    );
    const isMikeYohay = listgenUserID === "108245";
    let specialMikeYohay = (
      <div className="mike-yohay-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/Yohay+Davidson_CMYkGroup_Logo_Horiz_White.png"
          alt="Mike Yohay Logo"
          className="mike-yohay-cover-logo-img"
        />
      </div>
    );
    const julieWhitmer = listgenUserID === "109982";
    let julieWhitmerCornerLogo = (
      <div className="julie-whitmer-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/agent-JulieWhitmer_LOGO_white.png"
          alt="Julie Whitmer Logo"
          className="julie-whitmer-logo-img"
        />
      </div>
    );
    /*     co


    /*     const isJohnSaddi = listgenUserID === "106991";
    let specialJohnSaddi = (
      <div className="special-kj-team-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/042125_JohnSaddi-MounaKayed_LOGO.jpg"
          alt="Saddi and Kayed Logo"
          className="kj-team-logo-img"
        />
      </div>
    ); */

    /*  let flashbergerCornerLogo = (
      <div className="flashberger-corner-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/041125_S-Flashberger_LOGO-500px.png"
          alt="Flashberger Logo"
          className="flashberger-corner-logo-img"
        />
      </div>
    );
 */

    const isPaigeT = listgenUserID === "112993";

    let specialPaigeTLogo = (
      <div className="paige-t-top-left-corner-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/PaigeTitus_LOGO_white_080726.png"
          alt="Paige T Logo"
          className="paige-t-top-left-corner-logo"
        />
      </div>
    );
    let isTeresaM = listgenUserID === "x103680";
    let specialTeresaMLogo = (
      <div className="teresa-m-top-left-corner-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050826_TeresaMarlow_WhiteTranspt_logo.png"
          alt="Teresa M Logo"
          className="teresa-m-top-left-corner-logo"
        />
      </div>
    );

    const isChristineC = listgenUserID === "116385";
    let christineCCornerLogo = (
      <div className="christine-c-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050526_ChristineChristiansen_white-ICON.png"
          alt="Christine C Corner Logo"
          className="christine-c-cover-logo"
        />
      </div>
    );

    const isJennyTeng = listgenUserID === "102545";
    let jennyTengTopLeftCorner = (
      <div className="jenny-teng-top-left-corner">
        <div className="jenny-teng-top-left-corner-text">
          Leading Agents in 2024
        </div>
      </div>
    );

    /*     let specialKazemiTeamPhoto = (
      <div className="special-kazemi-team-photo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/kazemi-team-photo.jpg"
          alt="KazemiTeamPhoto"
          className="kazemi-team-photo-img"
        />
      </div>
    ); */
    let useKristenPCornerLogo = listgenUserID === "116399";

    let specialKristenPCornerLogo = (
      <div className="kristen-p-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/080626_KristenPalmerLogo_White.png"
          alt="Kristen Parker Corner Logo"
          className="kristen-p-cover-logo"
        />
      </div>
    );

    let useJohnGrayCornerLogo = listgenUserID === "114383";

    let specialJohnGrayCornerLogo = (
      <div className="john-gray-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040326_Goldman-JohnGray_Horiz-White-LOGO.png"
          alt="John Gray Corner Logo"
          className="john-gray-cover-logo"
        />
      </div>
    );

    let useScottHayesCornerLogo = listgenUserID === "106095";

    let specialScottHayesCornerLogo = (
      <div className="scott-hayes-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120325_ScottHayes_Logo.png"
          alt="Scott Hayes Corner Logo"
          className="scott-hayes-cover-logo"
        />
      </div>
    );
    let useLoriOlsonCornerLogo =
      listgenUserID === "116936" ||
      listgenUserID === "107269" ||
      listgenUserID === "107230";
    let specialLoriOlsonCornerLogo = (
      <div className="lori-olson-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/111325_MORE_Logo-ICON.png"
          alt="Lori Olson Logo"
          className="lori-olson-cover-logo"
        />
      </div>
    );
    let specialLoriOlsonCornerLogo2 = (
      <div className="lori-olson-cover-logo-container-2">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/MORETeam_QR-code_wBorder.png"
          alt="Lori Olson Logo 2"
          className="lori-olson-cover-logo-2"
        />
      </div>
    );
    let useElenaMendelson = listgenUserID === "109889";
    let specialElenaMendelsonLogo = (
      <div className="elena-mendelson-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/092525_ElenaMendelson_Monogram.png"
          alt="Elena Mendelson Logo"
          className="elena-mendelson-cover-logo"
        />
      </div>
    );
    let specialEricLarsonLogo = (
      <div className="eric-larson-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/110925_EricLarson_logo.png"
          alt="Eric Larson Logo"
          className="eric-larson-cover-logo"
        />
      </div>
    );
    let useGohnCornerLogo = listgenUserID === "107319";

    let specialGohnCornerLogo = (
      <div className="special-gohn-corner-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/GohnMarieMcFadden-whiteReverse_051525.png"
          alt="Gohn Logo"
          className="special-gohn-corner-logo"
        />
      </div>
    );

    let useNancyManningCornerLogo = listgenUserID === "114820";
    let specialNancyManningCornerLogo = (
      <div className="nancy-manning-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/062626_NancyManning_White-logo.png"
          alt="Nancy Manning Logo"
          className="nancy-manning-cover-logo"
        />
      </div>
    );
    let useLisaCochranCornerLogo = listgenUserID === "110007";
    let specialLisaCochranCornerLogo = (
      <div className="lisa-cochran-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/Lisa-Hopkins-Cochran_Logo_Final_Monogram_White_MaxHeight.png"
          alt="Lisa Cochran Logo"
          className="lisa-cochran-cover-logo"
        />
      </div>
    );

    let isMattT = listgenUserID === "104709";
    let specialMattTLogo = (
      <div className="matt-t-cover-logo-container">
        <img
          src={MattTLogo}
          alt="Matt Tenczar Logo"
          className="matt-t-cover-logo-img"
        />
      </div>
    );

    let isJoujou = listgenUserID === "112334";

    let specialJoujouLogo = (
      <div className="joujou-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/jou-jou-logo.png"
          alt="Joujou Logo"
          className="joujou-cover-logo-img"
        />
      </div>
    );

    let isKrisMoxley = listgenUserID === "107251";
    let specialKrisMoxleyLogo = (
      <div className="kris-moxley-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050626_KrisMoxley_White-Transpt_REALTOR.png"
          // src="https://d2onbxnrte2nim.cloudfront.net/041125_KrisMoxley_White-Transparent_500px.png"
          alt="Kris Moxley Logo"
          className="kris-moxley-cover-logo-img"
        />
      </div>
    );

    let specialSamanthaCostelloLogo = (
      <div className="samantha-costello-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/mcguire-olson-logo.png"
          alt="Samantha Costello Logo"
          className="samantha-costello-cover-logo-img"
        />
      </div>
    );

    let specialSummerCheLogo = (
      <div className="summer-che-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/SummerChe_whiteCover_ICON.png"
          alt="Samantha CheLogo"
          className="summer-che-cover-logo-img"
        />
      </div>
    );
    let isFinola = listgenUserID === "109796";
    let specialFinolaLogo = (
      <div className="finola-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120425_FinolaJaneFellner_White-logo.png"
          alt="Finola Logo"
          className="finola-cover-logo-img"
        />
      </div>
    );

    let isJamesRowbotham = listgenUserID === "109856";
    let specialJamesRowbothamLogo = (
      <div className="james-rowbotham-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120325_Rowbotham_RealEstate_White.png"
          alt="James Rowbotham Logo"
          className="james-rowbotham-cover-logo-img"
        />
      </div>
    );
    let isAnnMarie = listgenUserID === "109954";
    let specialAnnMarieLogo = (
      <div className="ann-marie-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/120725_AMNugent_WhiteLOGO.png"
          alt="Ann Marie Logo"
          className="ann-marie-cover-logo-img"
        />
      </div>
    );
    let isJessicaEvans = listgenUserID === "109901";

    let specialJessicaEvansLogo = (
      <div className="jessica-evans-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/010926_Evans-RidgeLogo_whiteReverse.png"
          alt="Jessica Evans Logo"
          className="jessica-evans-cover-logo-img"
        />
      </div>
    );

    let isAlexLam = listgenUserID === "105093";
    let specialAlexLamLogo = (
      <div className="alex-lam-cover-logo-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/040726_AlexLam_transWhite_LOGO.png"
          alt="Alex Lam Logo"
          className="alex-lam-cover-logo-img"
        />
      </div>
    );

    let topCornerLogo;
    let topCornerContainerStyles = "top-left-corner-logo-container";
    let topCornerImgStyles;

    if (listgenUserID === "117071") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/ButchHaze-logo_WHITEreverse.png";
    } else if (listgenUserID === "117275") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/Cece-Doricko_WHITEreverse.png";
    } else if (listgenUserID === "120440") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/ValSteeleTeam-Logo_WHITE-reverse.png";
    } else if (listgenUserID === "120543") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/Dunja-Green-MD_SQ-logo_blackWHITE.jpg";
    } else if (listgenUserID === "120535") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/MaggieVisser_WHITEreverse.png";
    } else if (listgenUserID === "117968") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/MarcusLee_WHITEreverse.png";
    } else if (listgenUserID === "117977") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/Alexander+Kiren_WHITEreverse.png";
    } else if (listgenUserID === "117912") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/JasonButtorf_WHITEreverse.png";
    } else if (listgenUserID === "120494") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/FouziaZaheer_logo-WHITEreverse.png";
    } else if (listgenUserID === "117244") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/nicholas-ashley-WHJITEreverse.png";
    } else if (listgenUserID === "120441") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/100226_MissyWyantSmit_logo-WHITErev.png";
    } else if (listgenUserID === "120408") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/ChrisOConnor-WhiteTrans_logo.png";
    } else if (listgenUserID === "120454") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/103126_JamesRowbotham_whiteRev.png";
      topCornerContainerStyles += " corner-container-left-40-top-30";
      topCornerImgStyles += " top-corner-logo-img-max-width-280";
    } else if (listgenUserID === "117955") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/FullerTeam_logo_White-Black_reverse.png";
    } else if (listgenUserID === "117364") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/LisaLyons_white_reverse_100826.png";
    } else if (listgenUserID === "101006") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/JoeRamos_NaplesLogo_WhiteREverse.png";
    } else if (listgenUserID === "108197" || listgenUserID === "120605") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/103126_alexmichas_whiteRev.png";
    } else if (listgenUserID === "114847") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/102826_SummerStubblefield_whiteReverse.png";
      topCornerContainerStyles += " corner-container-left-45-top-45";
      topCornerImgStyles += " top-corner-logo-img-max-height-85";
    } else if (listgenUserID === "117997") {
      topCornerLogo =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/lynn_finnegan_WhiteRev_103126.png";
    }
    let cornerLogoDiv = (
      <div className={topCornerContainerStyles}>
        <img
          src={topCornerLogo}
          alt="Top Corner Logo"
          className={`top-corner-logo-img ${topCornerImgStyles}`}
        />
      </div>
    );

    const isScar = teamName === "Team Scarborough";
    const isUhrig = listgenUserID === "100568";
    const isKellyMahan = listgenUserID === "100661";
    const isDanCrawford = listgenUserID === "100660";
    const isLisaMcCollum = listgenUserID === "100656";
    const isJessieSessions = listgenUserID === "100474";
    const isStephanieSills = listgenUserID === "105068";
    const isKristinArntz = listgenUserID === "100462";
    const isGaryPalacios = listgenUserID === "105790";
    const isAnnAlbanese = listgenUserID === "100063";
    const isEricLarson = listgenUserID === "109837";
    const isMicheleManzone = listgenUserID === "112366";
    const isCammieC = listgenUserID === "100652";
    const isGigi = listgenUserID === "107254";
    const isFlashberger = listgenUserID === "107253";
    const isSamanthaCostello = listgenUserID === "107215";
    const isTaylorK = listgenUserID === "104793";

    let presentedCreditStyle;
    if (listgenUserID === "109809") {
      presentedCreditStyle = "cover-credit-17";
    } else if (isFlashberger === "x") {
      presentedCreditStyle = "cover-credit-high-200";
    } else if (isStephanieSills || isGigi) {
      presentedCreditStyle = "stephanie-sills";
    } else if (isKellyMahan || isDanCrawford || isTaylorK) {
      presentedCreditStyle = "mccollum";
    } else if (isUhrig) {
      presentedCreditStyle = "uhrig";
    } else if (isScar) {
      presentedCreditStyle = "scar";
    } else if (isKristinArntz) {
      presentedCreditStyle = "arntz";
    } else if (isGaryPalacios) {
      presentedCreditStyle = "arntz";
    } else if (
      isLisaMcCollum ||
      isCammieC ||
      isJessieSessions ||
      isMicheleManzone
    ) {
      presentedCreditStyle = "mccollum";
    } else if (isAnnAlbanese) {
      presentedCreditStyle = "albanese";
    }
    //For team scarborough hedgerow area put credit in center
    const teamScarboroughPutInCenter =
      listgenUserID === "100588" && currentArea.mlsAreaID === "SBA-10C";
    let textDateStyles;
    if (mlsAreaID === "NPA-E0400Y") {
      textDateStyles = "playfair-date-text";
    } else if (listgenUserID === "104607" || listgenUserID === "109982") {
      textDateStyles = "left-justified-cover-date";
    } else if (listgenUserID === "x109954") {
      textDateStyles = "black-date-text";
    } else if (listgenUserID === "102843") {
      textDateStyles = "black-date-text";
    } else if (listgenUserID === "x107373" || listgenUserID === "x107876") {
      textDateStyles = "black-date-text";
    } else if (listgenUserID === "107251") {
      textDateStyles = "centered-cover-date";
    } else if (listgenUserID === "116936") {
      textDateStyles = "centered-cover-date";
    }

    let useWeissmanCornerLogo =
      listgenUserID === "107373" || listgenUserID === "107876";

    let specialWeissmanPhoto = (
      <div className="special-weissman-corner-logo-container">
        <img
          src={
            textDateStyles === "black-date-text"
              ? "https://d2onbxnrte2nim.cloudfront.net/non-covers/Kindred_Oriented_by_Compass_B_on_Transp-min.png"
              : "https://d2onbxnrte2nim.cloudfront.net/non-covers/021126_Weissmann_newLOGO-White.png"
          }
          //src="https://d2onbxnrte2nim.cloudfront.net/051525_JeffWeissman_LOGO_whiteReverse.png"

          alt="Weissman Logo"
          className="special-weissman-corner-logo"
        />
      </div>
    );
    // editor shows the live toggle; print always uses the saved preference
    const wantsAlternate = fromEditor
      ? this.state.useAlternatePhoto
      : currentArea?.coverPhotoPreference === "alternate";
    const alternateCoverPhoto = currentArea?.alternateCoverPhotoURL;
    let updatedPhoto = encodeURI(
      wantsAlternate && alternateCoverPhoto ? alternateCoverPhoto : cityPhoto,
    );
    if (mlsAreaID === "SFO-7CA") {
      //keep permanently
      updatedPhoto =
        "https://d2onbxnrte2nim.cloudfront.net/100726_sf_BeverlyBarnett.jpg";
      photographerArtistName = "Hide All Text";
    }
    let titleHeight = "";
    let darkerInfo;
    let coverComparisonStyles;
    if (listgenUserID === "103455") {
      darkerInfo = "darker-info-bg";
    } else if (listgenUserID === "106031") {
      coverComparisonStyles = "higher-up-cover-info";
    } else if (mlsAreaID === "CCA-4800E") {
      titleHeight = "upper-left-area-margin";
    } else if (mlsAreaID === "SCL-1S") {
      titleHeight = "title-height-top-117";
    } else if (listgenUserID === "100560") {
      titleHeight = "title-height-top-30";
    } else if (mlsAreaID === "CCA-1800K") {
      titleHeight = "title-container-width-96-perc el-cerrito-cover-container";
    }
    // let hoName = renderLogicUtil.getNoteGreetingTextV4(
    //   this.props.hoData.changeDetails,
    //   "&"
    // );

    // const detailsHOName = propertyUtil.changeDetailsHOName(
    //   this.props.hoData.changeDetails,
    //   true
    // );

    // if (isZech) {
    //   return (
    //     <div
    //       className={`qv4-cover-page-container ${quadrantModalOpen && "dim"}`}
    //     >
    //       <div
    //         style={{
    //           backgroundImage: `url('${updatedPhoto}')`,
    //         }}
    //         className={`cover-page-bg-photo`}
    //       />
    //       <div className="cover-page-color-overlay" />
    //     </div>
    //   );
    // } else {
    let showCoverDate = true;
    if (
      photographerArtistName?.includes("and Date") ||
      photographerArtistName?.includes("Hide All Text") ||
      photographerArtistName?.includes("Hide Date")
    ) {
      showCoverDate = false;
    }

    let noCoverDateDay =
      listgenUserID === "109879" || listgenUserID === "116050";
    let showCoverPageInfo = true;
    let showCoverCredit = true;
    if (listgenUserID === "102843") {
      showCoverPageInfo = false;
    }
    if (listgenUserID === "x104504") {
      showCoverPageInfo = false;
    }
    if (photographerArtistName?.includes("Hide Bottom Cover Info")) {
      showCoverPageInfo = false;
    }

    let agentCommentStyles;
    if (mlsAreaID === "SCL-1S") {
      agentCommentStyles = "larger-cover-subtitle-1";
    }
    let smallCoverSubtitle;

    let useBlackBackground = false;
    if (listgenUserID === "x104835") {
      useBlackBackground = true;
    }
    let hideAllText = false;

    if (
      listgenUserID === "102843" ||
      (photographerArtistName &&
        photographerArtistName.includes("Hide All Text"))
    ) {
      //keep this is the galli team
      hideAllText = true;
    }

    return (
      <div
        className={`${
          printVersion
            ? "print-qv4-cover-page-container"
            : "editor-qv4-cover-page-container"
        } ${quadrantModalOpen && "dim"}`}
      >
        {fromEditor && !quadrantModalOpen && (
          <CoverPhotoUploadButton
            agentData={agentData}
            currentArea={currentArea}
            showAllEditButtons={showAllEditButtons}
            useAlternatePhoto={this.state.useAlternatePhoto}
            isAlternateCoverPhotoEnabled={
              !!agentData?.isAlternateCoverPhotoEnabled
            }
            savingPhotoChoice={this.state.savingPhotoChoice}
            onPhotoChange={this.handlePhotoChoice}
          />
        )}
        {useBlackBackground ? (
          <div className={`cover-page-bg-photo black-background-cover`}>
            <img src={updatedPhoto} className="custom-black-background-image" />
          </div>
        ) : printVersion ? (
          <div className="cover-page-bg-photo cover-page-bg-photo-print">
            <img
              src={updatedPhoto}
              alt=""
              className="cover-page-bg-photo-img"
            />
          </div>
        ) : (
          <div
            style={{
              backgroundImage: `url('${updatedPhoto}')`,
            }}
            className={`cover-page-bg-photo xxxx`}
          />
        )}

        {(mlsAreaID === "SMA-438" ||
          mlsAreaID === "SMA-436" ||
          mlsAreaID === "SMA-470") && (
          <div className="dwyer-bottom-cover-disclaimer-container">
            <div className="dwyer-bottom-cover-disclaimer-text">
              *2025 MLS Listings Volume
            </div>
          </div>
        )}
        <div className="cover-page-color-overlay" />
        {!showCoverDate || hideAllText ? null : isPrintMode ? (
          <div className={`cover-page-edition ${textDateStyles}`}>
            {pmaPrintDate}
          </div>
        ) : agentData.demoCoverDate ? (
          <div className="cover-page-edition">
            {agentData.demoCoverDate}
            <span className="cover-page-small-caps">th</span>, {thisYear}
          </div>
        ) : (
          <div className={`cover-page-edition ${textDateStyles}`}>
            {month} {thisYear}
          </div>
        )}
        {listgenUserID === "104607" && (
          <div className="amin-cover-monogram">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/amin-white-monogram.png"
              alt="Amin monogram"
            />
          </div>
        )}
        {version === "ye" && (
          <div className="special-year-end-edition">Special Edition</div>
        )}

        {isVaitCover && specialVait}
        {isMikeYohay && specialMikeYohay}
        {isKJTeam && specialKJTeam}
        {isHeatherDonovan && specialHeatherDonovan}
        {isHeatherDonovan && specialHeatherDonovan2}
        {isAnnMarie && specialAnnMarieLogo}
        {isJessicaEvans && specialJessicaEvansLogo}
        {isAlexLam && specialAlexLamLogo}
        {isChristineC && christineCCornerLogo}
        {useLisaCochranCornerLogo && specialLisaCochranCornerLogo}
        {useNancyManningCornerLogo && specialNancyManningCornerLogo}
        {useKristenPCornerLogo && specialKristenPCornerLogo}
        {/*{isKerrySmith && specialKerrySmithQR}
   
        {/*{isJohnSaddi && specialJohnSaddi}*/}
        {isPaigeT && specialPaigeTLogo}
        {isTeresaM && specialTeresaMLogo}
        {isEricLarson && specialEricLarsonLogo}
        {isMattT && specialMattTLogo}
        {isKrisMoxley && specialKrisMoxleyLogo}
        {isJoujou && specialJoujouLogo}
        {isSummerChe && specialSummerCheLogo}
        {isFinola && specialFinolaLogo}
        {isJamesRowbotham && specialJamesRowbothamLogo}
        {isSamanthaCostello && specialSamanthaCostelloLogo}
        {/*{isFlashberger && flashbergerCornerLogo}*/}
        {/*{isKazemiTeam && specialKazemiTeamPhoto}*/}
        {useWeissmanCornerLogo && specialWeissmanPhoto}
        {isJennyTeng && jennyTengTopLeftCorner}
        {useGohnCornerLogo && specialGohnCornerLogo}
        {useElenaMendelson && specialElenaMendelsonLogo}
        {useLoriOlsonCornerLogo && specialLoriOlsonCornerLogo}
        {listgenUserID === "116936" && specialLoriOlsonCornerLogo2}
        {useScottHayesCornerLogo && specialScottHayesCornerLogo}
        {useJohnGrayCornerLogo && specialJohnGrayCornerLogo}
        {topCornerLogo && cornerLogoDiv}
        <div
          className={`cover-page-title-container ${titleHeight} ${
            isVaitCover && "vait-width"
          }`}
        >
          <div className={`cover-page-city-area`}>
            {listgenUserID === "101566" && (
              <div className="gummow-brothers-above-cover-logo">
                <img
                  src="https://d2onbxnrte2nim.cloudfront.net/gummow-Full-Logo-White.png"
                  alt="Gummow Brothers Cover Logo"
                />
              </div>
            )}

            {mlsAreaID === "ALA-4000S" && (
              <div className="market-update-container">
                <div className="market-update-text">
                  Your Neighborhood Market Update
                </div>
              </div>
            )}
            {(mlsAreaID === "sSMA-438" ||
              mlsAreaID === "xSMA-436" ||
              mlsAreaID === "xSMA-448") && (
              <div
                className={`dwyer-above-cover-container black-text-dwyer-cover`}
              >
                {mlsAreaID === "SMA-448" ? (
                  <div className="dwyer-above-cover-text smaller-dwyer-text">
                    A look at the 2025 real estate market in Hillsborough &
                  </div>
                ) : (
                  <div className="dwyer-above-cover-text">
                    A look at the 2025 real estate market in
                  </div>
                )}
              </div>
            )}
            {this.divideAreas(mlsNeighborhood, hideAllText)}
            {mlsAreaID === "SMA-470" && (
              <div className="dwyer-below-cover-container black-text-dwyer-cover">
                <div className="dwyer-below-cover-text higher-dwyer-text">
                  #1 Compass Team in Burlingame, Hillsborough and San Mateo
                  combined*
                </div>
              </div>
            )}
            {(mlsAreaID === "SMA-438" ||
              mlsAreaID === "SMA-436" ||
              mlsAreaID === "SMA-448") && (
              <div className="dwyer-below-cover-container black-text-dwyer-cover">
                {mlsAreaID === "SMA-448" ? (
                  <div className="dwyer-below-cover-text higher-dwyer-text">
                    #1 Compass Team in Hillsborough*
                  </div>
                ) : (
                  <div className="dwyer-below-cover-text higher-dwyer-text">
                    #1 Team at the #1 Brokerage in San Mateo County *
                  </div>
                )}
              </div>
            )}
            {(listgenUserID === "102286" || mlsAreaID === "SMA-360A") && (
              <div className="cover-photo-subtitle larger-cover-subtitle-1">
                REAL ESTATE UPDATE
              </div>
            )}

            {mlsAreaID === "SMA-436" && (
              <div className="cover-photo-subtitle">
                <p>Homes are selling fast and for over asking!</p>
                <p className="dt-smaller-cover-subtitle">
                  (see inside for statistics & analysis)
                </p>
              </div>
            )}

            {mlsAreaID === "SMA-438" && (
              <div className="cover-photo-subtitle">
                <p>Prices are up 18% (and inventory is low)</p>
              </div>
            )}
            {mlsAreaID === "CCA-5300F" && (
              <div className="cover-photo-subtitle subtitle-font-24">
                <p>
                  Homes are selling faster and there are far fewer available
                </p>
                <p className="dt-smaller-cover-subtitle">
                  (see inside for statistics & analysis)
                </p>
              </div>
            )}
            {mlsAreaID === "SMA-448" && (
              <div className="cover-photo-subtitle">
                <p>Hillsborough Prices Hitting Record Highs</p>
              </div>
            )}

            {(mlsAreaID === "CCA-4500H" || mlsAreaID === "CCA-4500N") && (
              <div className="cover-photo-subtitle">
                + Surrounding Neighborhoods
              </div>
            )}

            {smallCoverSubtitle && smallCoverSubtitle}

            {/*{mlsAreaID === "SMA-467" && (
                <div className="cover-photo-subtitle">NEWLY LISTED</div>
              )}
              {(mlsAreaID === "138" || mlsAreaID === "78") && (
                <div className="cover-photo-subtitle">NEWLY LISTED</div>
              )}*/}

            {/* {mlsAreaID === "SCL-1AA" && (
              <div className="cover-photo-subtitle">
                Your Luxury Lifestyle Specialists
              </div>
            )} */}
            {listgenUserID === "104709" && (
              <div className="cover-photo-subtitle lower-cover-subtitle">
                Where Luxury is in the Experience
              </div>
            )}
            {mlsAreaID === "SMA-350" && (
              <div className="cover-photo-subtitle small-cover-subtitle">
                YOUR NEIGHBORHOOD IN SAN CARLOS
              </div>
            )}
            {mlsAreaID === "SMA-334D" && (
              <div className="cover-photo-subtitle small-cover-subtitle">
                NEIGHBORHOOD
              </div>
            )}
            {agentComment && agentComment.includes("<br/>") ? (
              <div className={`cover-photo-subtitle ${agentCommentStyles}`}>
                {agentComment.split("<br/>")[0]}
                <br />
                {agentComment.split("<br/>")[1]}
              </div>
            ) : (
              <div className={`cover-photo-subtitle ${agentCommentStyles}`}>
                {agentComment}
              </div>
            )}

            {/*{mlsAreaID === "SBA-5F" && (
                <div className="cover-photo-subtitle">NEWLY OFFERED</div>
              )}*/}
            {/*{mlsAreaID === "SCL-15D" && (
              <div className="nomita-cover-subtitle-positioning">
                <p className="larger-nomita-subtitle">Just Sold</p>
                <p className="smaller-nomita-subtitle">
                  Classic Charm with Modern Amenities
                </p>
              </div>
            )}*/}
          </div>
        </div>
        {/*{mlsAreaID === "SCL-16F" && (
            <div className="cover-photo-subtitle">
              JUST LISTED By {agentData.listgenUserFirstName}{" "}
              {agentData.listgenUserLastName}
            </div>
          )}*/}

        {showCoverPageInfo && !hideAllText && (
          <CoverPageInfo
            agentData={agentData}
            printVersion={printVersion}
            currentArea={currentArea}
            isDemo={isDemo}
            hoData={hoData}
            coverPageDetails={coverPageDetails}
            hasFlippedTeam={hasFlippedTeam}
          />
        )}

        {listgenUserID === "102450" && (
          <div className="special-bottom-cover-photo-text">
            <p>
              Ranked top 1.5% of 1.6 million agents in the USA by Wall Street
              Journal
            </p>
            <p>Real Trends America's Best Real Estate Professionals</p>
          </div>
        )}
        {coverPhotoCredit1 &&
          coverPhotoCredit1.length > 1 &&
          showCoverCredit &&
          !hideAllText && (
            <div
              className={`corner-cover-photo-credit ${creditStyle} ${presentedCreditStyle}`}
              style={
                teamScarboroughPutInCenter ? { width: "100%", left: 0 } : {}
              }
            >
              <p
                style={
                  teamScarboroughPutInCenter ? { textAlign: "center" } : {}
                }
                dangerouslySetInnerHTML={{ __html: coverPhotoCredit1 }}
              ></p>

              {coverPhotoCredit2 && coverPhotoCredit2.length > 1 && (
                <p
                  style={
                    teamScarboroughPutInCenter ? { textAlign: "center" } : {}
                  }
                  dangerouslySetInnerHTML={{ __html: coverPhotoCredit2 }}
                ></p>
              )}

              {coverPhotoCredit3 && coverPhotoCredit3.length > 1 && (
                <p
                  style={
                    teamScarboroughPutInCenter ? { textAlign: "center" } : {}
                  }
                  dangerouslySetInnerHTML={{ __html: coverPhotoCredit3 }}
                ></p>
              )}
            </div>
          )}
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  updateCoverPhotoPreference: (preference) =>
    dispatch(pmaActions.updateCoverPhotoPreference(preference)),
});

export default connect(null, mapDispatchToProps)(withSnackbar(CoverPage));
